import { useState, useEffect } from "react";
import { loginUser, logoutUser } from "../../api/authApi";

export default function useAuth() {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse user data");
      }
    }
  }, []);

  const login = async (email, password) => {
    try {
      setLoading(true);
      const data = await loginUser(email, password);

      localStorage.setItem("access", data.access);
      localStorage.setItem("refresh", data.refresh);
      localStorage.setItem("user", JSON.stringify(data));

      setUser(data);

      return { success: true, data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.detail || "Invalid Credentials",
      };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      setLoading(true);
      await logoutUser(); // Call backend logout
    } catch (e) {
      // Continue even if API fails
    } finally {
      localStorage.clear();
      setUser(null);
      window.location.href = "/";
    }
  };

  return {
    login,
    logout,
    loading,
    user,           // ← Now exposed
  };
}